import { JsonObject } from '../app/json/jsonValue.js';
import { SlotPlaceholder } from './slotPlaceholder.js';
import type { PreprocessedTemplate } from './preprocessedTemplate.js';

export class SlottedTemplate {
    name: string = '';
    startIndex: number = 0;
    endIndex: number = 0;
    fullMatch: string = '';
    innerContent: string = '';
    slots: SlotPlaceholder[] = [];
    templateKey: string = '';
    resolvedTemplate: PreprocessedTemplate | null = null;
    resolvedJson: JsonObject | null = null;
    resolvedAppSite: string | null = null;
    resolvedTemplateName: string | null = null;

    constructor() {}

    get isResolved(): boolean {
        return this.resolvedTemplate !== null;
    }
}
